export default {
	'userCancel': 'การยกเลิกผู้ใช้',
	'addrLp': 'ที่อยู่สัญญา LP',
	'bscInLbb': 'BSC ไปยัง LBBCoin',
	'goSwap': 'การซื้อขาย CSwap',
	'sumLbb': 'สะสม {0} OC',
	'lookLbb': 'ดูสัญญา',
	'addrLbb': 'ที่อยู่สัญญาของ OC',
	'addrDead': 'ที่อยู่หลุมดำ',
	'addrMarket': 'ที่อยู่การตลาด',
	'ratioTotal': 'ขาย Slip Point ทั้งหมด: 10%',
	'ratioLp': 'ค่าสัมประสิทธิ์สภาพคล่อง: 5%',
	'ratioDead': 'ข. ค่าสัมประสิทธิ์การทำลาย: 3%',
	'ratioInv': 'c. ค่าสัมประสิทธิ์การเชิญ: 1%',
	'ratioMarket': 'd. ปัจจัยทางการตลาด: 1%',
	'contractDesc': 'ตรรกะการใช้งานห่วงโซ่เต็มรูปแบบ',
	'contract': 'สัญญา',
	'inviteTotal': 'รางวัลบัตรเชิญ Full Web: {0} OC',
	'inviteMy': 'รางวัลคำเชิญของฉัน: {0} OC',
	'lpTotal': 'รางวัลสภาพคล่องสุทธิทั้งหมด: {0} OC',
	'lpMy': 'โบนัสสภาพคล่องของฉัน: {0} OC',
	'lpDesc': 'สภาพคล่อง My / Full Net: {0} / {1} LCC',
	'lpAdd': 'เพิ่มสภาพคล่อง',
	'lp': 'สภาพคล่อง',
	'invSell': 'โบนัสรับเชิญสูงสุด 1%',
	'lpSell': 'การถือครองสภาพคล่อง 5% ของเงินรางวัลถ่วงน้ำหนักต่อการขาย',
	'myInvites': 'คำเชิญของฉัน',
	'effective': 'effective',
	'ineffective': 'ineffective',
	'myInviter': 'อ้างอิงของฉัน',
	'invite': 'คำเชิญ',
	'inviteNotice1': 'ส่ง 0.1 OC ให้กันและกัน',
	'inviteNotice2': 'เมื่อได้รับการยืนยันจากอีกฝ่ายแล้วคือการเชิญชวนสำเร็จ',
	'inviteBind': 'โปรดผูกการอ้างอิงของคุณ',
	'chainConfirm': 'ในห่วงโซ่บน · ·',
	'{0} Operate Fast': '{0} ทำงานบ่อยเกินไปโปรดดำเนินการต่อใน {1} วินาที',
	'English': 'English',
	'Chinese': '中文',
	'Conrim': 'ยืนยัน',
	'Osnft Detail': 'ดูรายละเอียด',
	'{0} Not Enogugh': '{0} ของคุณไม่เพียงพอ',
	'Operate Success': 'ความสำเร็จในการดำเนินงาน',
	'zlang143': 'คัดลอกสำเร็จ',
	'Cht': '繁體中文',
	'YueNan': 'Việt Nam',
	'YinNi': 'Bahasa Indonesia',
	'RiWen': ' にほんご',
	'HanWen': '한국어',
	'TaiWen': 'ไทย',
	'ALaBoWen': ' العربية ',
	'ocLockTitle': 'ล็อก OC',
	'ocLockDeposit': 'ฝาก',
	'ocLockActive': 'Status',
	'ocLockReleased': 'ปล่อยแล้ว',
	'ocLockClaim': 'ถอน',
	'themeNeon': 'นีออนบลู',
	'themeIce': 'วงจรน้ำแข็ง',
	'themeViolet': 'ม่วงทอง',
	'themeAurora': 'ออโรร่ามินต์',
	'themeEmber': 'คืนเปลวไฟ',
	'themeMono': 'โมโนเข้ม',
	'Refresh': 'Refresh',
	'No Records': 'No Records',
	'eventLogs': 'Event Logs',
	'eventCount': 'Records',
	'eventTotal': 'Amount Summary',
	'eventAll': 'All',
	'eventInviteFeature': 'Invite',
	'eventRewardFeature': 'Rewards',
	'eventBonusFeature': 'Mining',
	'eventLockFeature': 'Lock',
	'eventLock': 'Lock',
	'eventRelease': 'Release',
	'eventClaim': 'Claim',
	'eventBonus': 'Bonus',
	'eventInvite': 'Invite',
	'eventTransfer': 'Transfer',
	'eventOcLocked': 'OC Locked',
	'eventOcStaticRelease': 'Static Release',
	'eventOcDynamicRelease': 'Dynamic Release',
	'eventOcClaimed': 'Lock Claim',
	'eventBonusTriggered': 'Bonus Distributed',
	'eventBonusReceived': 'Bonus Received',
	'eventInviteRequested': 'Invite Requested',
	'eventDirectReward': 'Direct Reward',
	'eventLiquidityReward': 'Liquidity Reward',
	'eventSlowQueryProgress': 'Query is slow, checked block {0}/{1}',
	'eventTenLevelBonus': 'Ten-Level Mining',
	'eventTenLevelBonusReceived': 'Ten-Level Mining Received',
	'eventReferralConfirmed': 'Referral Confirmed',
	'eventEffectiveInvite': 'Effective Invite',
	'eventEffectiveLp': 'Effective Account',
	'eventTransferIn': 'Transfer In',
}
